import React from 'react';
import { useSelector } from 'react-redux';
import * as selectors from '../../selectors';
import { IntegrationDetailsContent } from './components/IntegrationDetailsContent';

/**
 * Displays details for an integration from the all-integrations view.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {string} props.integrationId
 * @param {Function|null} props.onClose
 */
export const AllIntegrationsDetailsModal = ({ companyId, integrationId, onClose = null }) => {
    const integration = useSelector(state => selectors.getIntegration(state, integrationId));

    if (!integration) return null;

    return (
        <IntegrationDetailsContent
            companyId={companyId}
            integration={integration}
            onClose={onClose}
        />
    );
};

export default AllIntegrationsDetailsModal;
